import {
  module_version,
} from 'api/services/content/module_version';
import {
  CMS_LEVEL_PATH_SERVICES,
  CMS_LEVEL_USER_PATH_SERVICES,
  EPG_EVENTS_BY_GENRE_PATH,
  FAVORITE_USER_PATH_SERVICES,
  MULTI_CONTENT_SEARCH_PATH_SERVICES,
  MULTI_PBI_PATH_SERVICES,
  PURCHASE_BUTTON_INFO_PATH_SERVICE,
  PURCHASE_NODE_ID_PATH_SERVICES,
  USER_CHANNELS_SEEN_PATH,
  USER_RECOMMENDATIONS,
  USER_SEEN_PATH_SERVICES,
  WORKFLOWSTART_PATH_SERVICE,
} from 'api/services/content/paths';
import { USER_AUD_PREFERENCES_PATH } from 'api/services/user/paths';

export const transformCmsRequest = (request, url = '') => {
  if (url?.includes(CMS_LEVEL_PATH_SERVICES)) {
    request.params.module_version = module_version;
    delete request.params?.user_token;
  }
  if (url?.includes(CMS_LEVEL_USER_PATH_SERVICES)) {
    request.params.module_version = module_version;
    delete request.params?.user_token;
  }
};

export const transforFavorited = (request, url = '') => {
  if (url?.includes(FAVORITE_USER_PATH_SERVICES)) {
    request.params.module_version = module_version;
    request.params.api_version = null;
  }
};

export const transforSeen = (request, url = '') => {
  if (url?.includes(USER_SEEN_PATH_SERVICES)) {
    request.params.module_version = module_version;
    request.params.api_version = null;
  }
};

export const transformUserChannelsLiveSeen = (request, url = '') => {
  if (url?.includes(USER_CHANNELS_SEEN_PATH)) {
    request.params.api_version = null;
    delete request.params?.HKS;
    delete request.params?.user_token;
  }
};
export const transformEpgEventsByGenre = (request, url = '') => {
  if (url?.includes(EPG_EVENTS_BY_GENRE_PATH)) {
    request.params.api_version = null;
    delete request.params?.HKS;
    delete request.params?.user_token;
  }
};

export const transformPurchaseNodeIdRequest = (request, url) => {
  if (url?.includes(PURCHASE_NODE_ID_PATH_SERVICES)) {
    const { token } = localStorage.getItem('loginInfo.logged_user_data')
      ? JSON.parse(localStorage.getItem('loginInfo.logged_user_data'))
      : '';
    delete request.params?.user_token;
    delete request.params?.user_id;
    delete request.params?.HKS;
    request.headers.Authorization = `Bearer ${token}`;
  }
};

export const transformMultiPbiRequest = (request, url) => {
  const loggedUserData = JSON.parse(
    localStorage.getItem('loginInfo.logged_user_data'),
  );
  const { user_id } = loggedUserData || {};
  if (url.includes(MULTI_PBI_PATH_SERVICES)) {
    delete request.params?.user_token;
    delete request.params?.format;
    if (user_id) {
      request.params.user_id = user_id;
    }
  }
};

export const transformPbiRequest = (request, url) => {
  if (url.includes(PURCHASE_BUTTON_INFO_PATH_SERVICE)) {
    request.headers['user-token'] = request.params?.user_token;
  }
};

export const transformMultiContentSearchRequest = (request, url) => {
  if (url.includes(MULTI_CONTENT_SEARCH_PATH_SERVICES)) {
    delete request.params?.user_token;
  }
};

export const transformWorkflowStart = (request, url) => {
  if (url.includes(WORKFLOWSTART_PATH_SERVICE)) {
    request.headers['user-token'] = request.params?.user_token;
  }
};

export const transformAudPreferences = (request, url) => {
  if (url.includes(USER_AUD_PREFERENCES_PATH)) {
    const loggedUserData = JSON.parse(
      localStorage.getItem('loginInfo.logged_user_data'),
    );
    request.params.user_id = loggedUserData.user_id;
  }
};

export const transformUserRecommendationsRequest = (request, url)=>{
  if(url?.includes(USER_RECOMMENDATIONS)){
        delete request.params?.user_token;
        delete request.params?.region;
        delete request.params?.HKS;
        delete request.params?.event_date;
        delete request.params.user_id;
        delete request.params?.lasttouch;

  }
}
